module.exports = __webpack_public_path__ + "static/media/fintechgalaxy.04dd306a.jpg";